import { useCallback } from 'react';

import { So5FixtureEvent } from '@sorare/core/src/__generated__/globalTypes';
import { useNextSo5FixtureTeamSlugs } from '@sorare/core/src/hooks/config/useNextSo5FixtureTeamSlugs';

export const useFormatActiveFixtureLabel = () => {
  const teamsPlayingNextDailyFixture = useNextSo5FixtureTeamSlugs(
    So5FixtureEvent.DAILY
  );
  const teamsPlayingNextWeeklyFixture = useNextSo5FixtureTeamSlugs(
    So5FixtureEvent.CLASSIC
  );

  return useCallback(
    (slug: string | false, type: So5FixtureEvent) => {
      const selectedFixture = (
        type === So5FixtureEvent.DAILY
          ? teamsPlayingNextDailyFixture
          : teamsPlayingNextWeeklyFixture
      ).find(f => f.slug === slug);

      if (selectedFixture) {
        return selectedFixture.longDisplayName;
      }
      return '';
    },
    [teamsPlayingNextDailyFixture, teamsPlayingNextWeeklyFixture]
  );
};
